import { render, staticRenderFns } from "./DocutaxSubmissionList.vue?vue&type=template&id=718d5b50&scoped=true&"
import script from "./DocutaxSubmissionList.vue?vue&type=script&lang=js&"
export * from "./DocutaxSubmissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d5b50",
  null
  
)

export default component.exports